/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_Document_AnalysisInputs */

const en_back_to_document_analysis = /** @type {(inputs: Back_To_Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to document analysis overview`)
};

const nl_back_to_document_analysis = /** @type {(inputs: Back_To_Document_AnalysisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terug naar documentanalyse overzicht`)
};

/**
* | output |
* | --- |
* | "Back to document analysis overview" |
*
* @param {Back_To_Document_AnalysisInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const back_to_document_analysis = /** @type {((inputs?: Back_To_Document_AnalysisInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_Document_AnalysisInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_back_to_document_analysis(inputs)
	return en_back_to_document_analysis(inputs)
});